import { defaultHttpClient } from '../../httpClient';
import type { GetHomeTabsResponse } from './types';

export const getHomeTabs = () => {
  return defaultHttpClient
    .request<GetHomeTabsResponse>({
      method: 'GET',
      url: '/api/v2/home/tabs/',
    })
    .then(result => result.data);
};
